import { Box, IconButton, useTheme, Popover } from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

const Topbar = ({ setIsSidebar, handleLogout }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);


  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* TOGGLE SIDEBAR BUTTON */}
      <IconButton onClick={() => setIsSidebar((prev) => !prev)}>
        {/* ADD ICON HERE */}
      </IconButton>

      {/* SEARCH BAR */}
      {/* <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box> */}

      {/* ICONS */}
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <PersonOutlinedIcon />

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            PaperProps={{
              sx: {
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "visible", 
                padding: 0,
              },
            }}
          >
            <Link to="/" onClick={handleLogout} style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  backgroundColor: "#2E3B55",
                  borderRadius: "10px",
                  width: "110px",
                  height: "60px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  gap: "8px",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  overflow: "hidden",
                  "&:hover": {
                    backgroundColor: "#3B4C6D",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <LogoutOutlinedIcon sx={{ fontSize: 24, color: "#fff" }} />
                <span
                  style={{
                    fontSize: "19px",
                    color: "#fff",
                    marginTop: "1px",
                    lineHeight: 1.2,
                  }}
                >
                  Logout
                </span>
              </Box>
            </Link>
          </Popover>

        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;